class CartPageForm {

    constructor($el) {

        this.$el = jQuery($el);// just to make sure
        this.$quantityInputs = jQuery('[data-quantity-input]', this.$el );

        if(this.$quantityInputs.length){
            this.initEvents()
        }

    }

    initEvents(){
        this.$quantityInputs.on( 'wpshopify.quantityChanged', this.submitForm.bind(this) );
    }

    submitForm(){
        this.$el.submit();
    }


    static initialize(){
        window.WPShopify = window.WPShopify || {};
        window.WPShopify.Cart = window.WPShopify.Cart || {};

        window.WPShopify.Cart.CartPageForm = new CartPageForm(jQuery('#CartPageForm'));

    }
}

CartPageForm.initialize();